import { createContext, useContext, useState } from "react";

const VotacaoContext = createContext();

export const useVotacao = () => useContext( VotacaoContext );

export const VotacaoProvider = ({ children }) => {
    const [cpf, setCpf] = useState("");
    const [validUser, setValidUser] = useState( false );

    return(
        <VotacaoContext.Provider
            value={{ cpf, setCpf, validUser, setValidUser }}
        >
            { children }
        </VotacaoContext.Provider>
    )

}